<h2>{{ 'When You Need to Have Surgery' | translate }}</h2>

<div [innerHTML]="introParagraphText"></div>

@if (surgeryTimelineChartKey) {
    <p>{{ 'Here is a visual aid to get you started:' | translate }}</p>
    <core-timeline-chart
        [chartReference]="surgeryTimelineChartKey"
        [timelineChartData]="parentBlock?.data?.timelineChartData"></core-timeline-chart>
}
<hr />

@if (lengthOfLeaveText) {
    <section class="loa-tool-section">
        <img [src]="parentBlock?.data.lengthImage" class="loa-tool-section__icon-image" alt="calendar" />
        <div class="loa-tool-section__text">
            <h2 class="loa-tool-section__heading">{{ 'Length of Leave' | translate }}</h2>
            <div [innerHTML]="lengthOfLeaveText"></div>
        </div>
    </section>
    <hr />
}

@if (payText) {
    <section class="loa-tool-section">
        <img [src]="parentBlock?.data.payImage" class="loa-tool-section__icon-image" alt="Bank" />
        <div class="loa-tool-section__text">
            <h2 class="loa-tool-section__heading">{{ 'Pay' | translate }}</h2>
            <div [innerHTML]="payText"></div>
        </div>
    </section>
    <hr />
}

@if (processChecklist) {
    <section class="loa-tool-section">
        <img [src]="parentBlock?.data.processImage" class="loa-tool-section__icon-image" alt="Process checklist" />
        <div class="loa-tool-section__text">
            <h2 class="loa-tool-section__heading">{{ 'Process' | translate }}</h2>
            <div [innerHTML]="processChecklist"></div>
        </div>
    </section>
    <hr />
}

@if (thingsToConsider) {
    <section class="loa-tool-section loa-tool-section--grey-bg">
        <h2 class="loa-tool-section__heading">{{ 'Things to Consider' | translate }}</h2>
        <div [innerHTML]="thingsToConsider"></div>
    </section>
}
